import PropTypes from 'prop-types';

import { Step, Stepper, StepButton, Typography } from '@mui/material';

// Fasi dell'onboarding viste dall'azienda, in ordine. L'ultima è a cura di Studio.
export const ONBOARDING_STEPS = [
  { key: 'documents', label: 'Documenti' },
  { key: 'delegations', label: 'Deleghe' },
  { key: 'activation', label: 'Attivazione' },
];

export default function OnboardingSteps({ active, status = {}, onSelect }) {
  return <Stepper nonLinear alternativeLabel activeStep={ONBOARDING_STEPS.findIndex((step) => step.key === active)}>
    {ONBOARDING_STEPS.map((step) => {
      const { done = false, caption, attention = false } = status[step.key] || {};
      return <Step key={step.key} completed={done}>
        <StepButton onClick={() => onSelect(step.key)} optional={caption && <Typography variant="caption" component="div" color={attention ? 'warning.main' : 'text.secondary'}>{caption}</Typography>}>{step.label}</StepButton>
      </Step>;
    })}
  </Stepper>;
}

OnboardingSteps.propTypes = { active: PropTypes.string.isRequired, status: PropTypes.object, onSelect: PropTypes.func.isRequired };
